import React from "react";
import "./breadcrumb.sass";
import classNames from "classnames";

export interface BreadcrumbItem {
  onClick?: Function;
  name: string;
  child?: BreadcrumbItem;
}
export interface BreadcrumbProps {
  item: BreadcrumbItem;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({item}) => {
  const getChildBreadcrumb: any = (item: BreadcrumbItem) => {
    if (item) {
      return (
        <>
          <div
            className={classNames({url: item.child})}
            data-testid={`breadcrumb-item-${item.name}`}
            onClick={() => item.onClick?.()}
          >
            {item.name}
            {item.child ? "/" : ""}
          </div>
          {getChildBreadcrumb(item.child)}
        </>
      );
    }
  };

  return (
    <div className="breadcrumb" data-testid={`breadcrumb`}>
      {getChildBreadcrumb(item)}
    </div>
  );
};

export default Breadcrumb;
